import { useNavigate, useParams } from "react-router-dom";
import HeaderComponent from "../../components/header";
import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { RolesService, UserChangePasswordService, UserShowService, UserUpdateService } from "../../services/users";
import { ToastErro, ToastSucesso } from "../../components/toast";
import CardComponent from "../../components/card";
import InputComponent from "../../components/input";
import LoadingComponent from "../../components/loading";
import ContainerComponent from "../../components/conatiner";

const UsersUpdatePage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState<boolean>(true);

    const [roles, setRoles] = useState<any>([]);
    const [userRoles, setUserRoles] = useState<number[]>([]);

    const { id } = useParams();

    // variaveis para editar
    const [name, setName] = useState<string>('');
    const [username, setUsername] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    // variaveis para editar

    const [password, setPassword] = useState<string>('');
    const [confPassword, setConfPassword] = useState<string>('');

    // pequisar informações da página
    const getData = async () => {

        setLoading(true);

        await RolesService().then(resp => {
            setRoles(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        await UserShowService(parseInt(id!)).then(resp => {
            setName(resp.data.user.name);
            setUsername(resp.data.user.username);
            setEmail(resp.data.user.email);
            setUserRoles(resp.data.roles);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // pequisar informações da página

    // funcao para salvar usuário
    const updateUser = async (e: FormEvent) => {

        e.preventDefault();

        let arrayUserRoles: any = [];

        (window as any).$(".userRole:checked").each((i: number, e: any) => {
            arrayUserRoles.push(e.value);
        });

        if (arrayUserRoles.length < 1) {
            ToastErro('Selecione no mínimo 1 permissão!');
            return;
        }

        setLoading(true);

        await UserUpdateService(parseInt(id!), name, username, email, JSON.stringify(arrayUserRoles)).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/users');
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoading(false);

    }
    // funcao para salvar usuário

    // função para alterar a senha do usuário
    const changePassword = async (e: FormEvent<HTMLFormElement>) => {

        e.preventDefault();

        if(password.length < 6)
        {
            ToastErro('A senha deve conter no mínimo 6 caracteres!');
            return;
        }

        if(password !== confPassword)
        {
            ToastErro('As senhas não são iguais!');
            return;
        }

        setLoading(true);

        await UserChangePasswordService(parseInt(id!), password).then(resp => {
            ToastSucesso(resp.data.message);
            navigate('/users');
        }).catch(error => {
           ToastErro(error?.response?.data?.message);
           setLoading(false);
        });

    }
    // função para alterar a senha do usuário

    useEffect(() => {
        getData();
    }, []);

    return (
        <>
            <HeaderComponent
                title="Editar Usuário"
                button="Voltar"
                iconButton="arrow_back"
                onClick={() => navigate('/users')}
            />
            <ContainerComponent>
                {
                    loading

                        ?

                        <LoadingComponent />

                        :

                        <>
                            <div className="row">
                                <form onSubmit={updateUser}>
                                    <div className="row">
                                        <CardComponent
                                            col={8}
                                        >
                                            <>
                                                <div className="card-title mb-4">
                                                    Informações do Usuário
                                                </div>
                                                <div className="row">
                                                    <InputComponent
                                                        label="Nome"
                                                        col={12}
                                                        defaultValue={name}
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                <div className="row">
                                                    <InputComponent
                                                        label="Usuário"
                                                        col={6}
                                                        defaultValue={username}
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => setUsername(e.target.value)}
                                                        required
                                                    />
                                                    <InputComponent
                                                        label="E-mail"
                                                        col={6}
                                                        defaultValue={email}
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                        required
                                                    />
                                                </div>
                                                <div className="d-flex justify-content-end mt-4">
                                                    <button className="btn btn-primary" type="submit">Salvar</button>
                                                </div>
                                            </>
                                        </CardComponent>
                                        <CardComponent
                                            col={4}
                                        >
                                            <>
                                                <div className="card-title mb-4">
                                                    Permissões do Usuário
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <table className="table">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">Selecione</th>
                                                                    <th scope="col">ID</th>
                                                                    <th scope="col">Descrição</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    roles.map((r: any) => {
                                                                        return (
                                                                            <tr key={r.id}>
                                                                                <td><input type="checkbox" className="userRole" defaultChecked={userRoles.includes(r.id)} defaultValue={r.id} /></td>
                                                                                <td>{r.id}</td>
                                                                                <td>{r.description}</td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </>
                                        </CardComponent>
                                    </div>
                                </form>
                            </div>
                            <div className="row">
                                <CardComponent
                                    col={4}
                                >
                                    <form onSubmit={changePassword}>
                                        <div className="card-title mt-4">
                                            Alterar Senha
                                        </div>
                                        <div className="row mt-4">
                                            <InputComponent
                                                label="Senha"
                                                col={12}
                                                defaultValue={password}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                                type={'password'}
                                                required
                                            />
                                        </div>
                                        <div className="row">
                                            <InputComponent
                                                label="Confirme a Senha"
                                                col={12}
                                                defaultValue={confPassword}
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => setConfPassword(e.target.value)}
                                                type={'password'}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end mt-4">
                                            <button className="btn btn-primary" type="submit">Alterar Senha</button>
                                        </div>
                                    </form>
                                </CardComponent>
                            </div>
                        </>
                }
            </ContainerComponent>
        </>
    );

}

export default UsersUpdatePage;